import React from "react";
import App from "../App.js";
import { AdminWrapper } from "../admin/admin-employer/components/adminwrapper";
export const PublicRouterLayout = ({ children }) => (
  <>
    {children}
  </>
);
export const AdminRouterLayout = ({ children }) => <AdminWrapper>{children}</AdminWrapper>;
